import * as Sentry from '@sentry/react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import 'nprogress/nprogress.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'simplebar/dist/simplebar.min.css';
import './global.css';
import './i18n/index.ts';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
});

Sentry.init({
  enabled: false,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        'https://meili.lockspace.dev.signalos.app',
        'https://api.lockspace.dev.signalos.app',
        /^https:\/\/meili\.lockspace\.dev\.signalos\.app/,
        /^https:\/\/api\.lockspace\.dev\.signalos\.app/,
      ],
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
    }),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'https://meili.lockspace.dev.signalos.app',
    'https://api.lockspace.dev.signalos.app',
    /^https:\/\/meili\.lockspace\.dev\.signalos\.app/,
    /^https:\/\/api\.lockspace\.dev\.signalos\.app/,
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: import.meta.env.PROD ? 'production' : 'development',
  // enabled: import.meta.env.PROD,
});

const rootElement = document.getElementById('root')!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
}
